import { shippingReciveAccioneRoles } from '../../acciones-roles/areas-de-trabajo/shipping-recive-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const ShippingReceiveRoutes: SideBarButton = {
  data: {
    name: 'Recibo',
    appendUrl: './shipping-receive',
    roles: [...shippingReciveAccioneRoles.sideNavActions.shippingReceive],
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Registrar POs',
        url: '/register/purchase-order',
        roles: [
          ...shippingReciveAccioneRoles.sharedActions.registerPurchaseOrder,
        ],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Hojas de Inspeccion',
        url: '/inspection-sheets',
        roles: [...shippingReciveAccioneRoles.sharedActions.inspectionSheets],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Seguimineto de Camiones',
        url: '/box/tracing',
        roles: [...shippingReciveAccioneRoles.sharedActions.boxTracing],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Actualizar estado de Camiones',
        url: '/box/status',
        roles: [...shippingReciveAccioneRoles.sharedActions.boxStatus],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Editar camiones',
        url: '/box/edit',
        roles: [...shippingReciveAccioneRoles.sharedActions.boxEdit],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Registar regreso de scrap',
        url: '/scrap-refund',
        roles: [...shippingReciveAccioneRoles.sharedActions.scrapRefund],
      },
      options: PreConfigButton3,
    },
  ],
};
